import React from "react";
import clsx from "clsx";

export interface InputProps {
    name: string,
    errors: any,
    register: any,
    control?: any
    rows?: number,
    className?: string,
    prefix?: string,
    children?: React.ReactNode;
    classError?: string,
}

export const FormCheckbox = (props: InputProps): JSX.Element => {

    return (
        <div className={clsx(props.className, props.errors[props.name]?.type === 'manual' && props.classError && props.classError)}>
            <label className="checkbox" htmlFor={props.name}>
                <input type="checkbox"
                       className="checkbox"
                       name={props.name}
                       id={props.name}
                       {...props.register(props.name)}
                       aria-invalid={props.errors[props.name] ? "true" : "false"}
                />
                <div>{props.children}</div>
            </label>
            {props.errors[props.name]?.type === 'manual' &&
                <label className="help-error">{props.errors[props.name]?.message}</label>}
        </div>

    );
}


